import styled from 'styled-components';

export const StyledUserImg = styled.img`
    width: 80%;
    margin: 10px 0;
`;

export const HiddenInput = styled.input`
    visibility: hidden;
`;

export const LoadingContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px 0 10px;
`;

export const ButtonTextContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
